import { clsx } from 'clsx';
import { useEffect } from 'react';

import { useStoreSwitcher } from '@jane/bloom/hooks/storeSwitcher/useStoreSwitcher';
import { useScrollLock } from '@jane/bloom/hooks/useScrollLock';

import { ReservationModeWarningModal } from './storeSwitcher/ReservationModeWarningModal';
import { StoreSwitcherForm } from './storeSwitcher/storeSwitcherForm';

import styles from './storeSwitcher.module.css';

export function StoreSwitcher() {
  const { isVisible, toggleVisibility } = useStoreSwitcher();
  const { setScrollLock } = useScrollLock();

  useEffect(() => {
    setScrollLock(isVisible);
  }, [isVisible, setScrollLock]);

  return (
    <>
      {/** @todo use elements with appropriate role */}
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
      <div
        onClick={toggleVisibility}
        className={clsx({
          [styles['overlay']]: isVisible,
        })}
      />
      <ReservationModeWarningModal />

      <div className={styles['form']}>
        {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
        <div
          className={clsx(styles['switcher'], {
            [styles['switcher--expanded']]: isVisible,
          })}
          hidden={!isVisible}
          onKeyDown={(event) => {
            if (event.key === 'Escape' && isVisible) {
              toggleVisibility();
            }
          }}
          data-testid="store-switcher-form"
        >
          <StoreSwitcherForm />
        </div>
      </div>
    </>
  );
}
